import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  doc, 
  getDoc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  serverTimestamp, 
  query, 
  orderBy, 
  where,
  GeoPoint, 
  connectFirestoreEmulator
} from "firebase/firestore";
import { 
  getStorage, 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject,
  connectStorageEmulator
} from "firebase/storage";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBC-KOpGEk5BrwkupPXjf9gV3Vm5G4c9yo",
  authDomain: "b-b-q-finder-qcoftk.firebaseapp.com",
  projectId: "b-b-q-finder-qcoftk",
  storageBucket: "b-b-q-finder-qcoftk.appspot.com",
  messagingSenderId: "866291341396",
  appId: "1:866291341396:web:b76b754a6b8ab4581cf5c1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// Debug Firebase interactions
console.log("Firebase initialized with config:", firebaseConfig);

// Collection references - make sure these match your Flutter app
const restaurantsCollection = collection(db, "Restaurants");

// Test connection by logging a query attempt
async function testFirestoreConnection() {
  try {
    console.log("Testing Firestore connection...");
    const querySnapshot = await getDocs(restaurantsCollection);
    console.log(`Successfully connected to Firestore. Found ${querySnapshot.size} restaurants.`);
    querySnapshot.forEach(doc => {
      console.log(`Document ID: ${doc.id}`);
    });
    return true;
  } catch (error) {
    console.error("Error connecting to Firestore:", error);
    return false;
  }
}

// Run test connection
testFirestoreConnection();

export {
  app,
  db,
  storage,
  restaurantsCollection,
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
  where,
  GeoPoint,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
};